import { HttpClient, HttpEvent } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { ApiControllerModel, ApiControllerRequest, Types, UploadedFileDto } from '@siza-staff-care/shared/data';
import { Observable } from 'rxjs';

@Injectable({
	providedIn: 'root',
})
export class JadeService {
	private abortNextRequest = false;

	constructor(private http: HttpClient) {}

	setAbortNextRequest() {
		this.abortNextRequest = true;
	}

	controllerRequest<TResult>(operation: string, params: ApiControllerModel): Observable<TResult> {
		const abort = this.abortNextRequest;
		this.abortNextRequest = false;

		const url = this.buildUrl();
		return this.http.post<TResult>(url, {
			$type: Types.ApiControllerRequest,
			abort,
			params: {
				...params,
				operation,
			},
		} as Partial<ApiControllerRequest>);
	}

	post<TResult>(params: object): Observable<TResult> {
		const url = this.buildUrl();
		return this.http.post<TResult>(url, params);
	}

	get<TResult>(path: string): Observable<TResult> {
		const url = this.buildUrl() + '/' + path;
		return this.http.get<TResult>(url);
	}

	/**
	 * Posts to the refresh endpoint, to get a refreshed JWT. The refresh cookie will be attached by the browser.
	 */
	postRefresh(): Observable<string> {
		const url = this.buildUrl('refresh');
		return this.http.post<string>(url, {
			$type: Types.RefreshTokenDto,
		});
	}

	/**
	 * Posts a File to upload to the server.
	 * @param file
	 * @param opts
	 * @returns
	 */
	uploadFile(
		file: File,
		opts: { fileKey: string; forMerge?: boolean; sampleUrl?: string },
	): Observable<HttpEvent<UploadedFileDto>> {
		const url = this.buildUrl('upload');
		const formData = new FormData();
		formData.append('file', file);

		formData.set('fileName', encodeURIComponent(file.name));
		formData.set('fileKey', encodeURIComponent(opts.fileKey));
		if (opts.forMerge !== undefined) {
			formData.set('forMerge', opts.forMerge.toString());
		}

		if (opts.sampleUrl !== undefined) {
			formData.set('sampleUrl', opts.sampleUrl);
		}
		return this.http.post<UploadedFileDto>(url, formData, {
			reportProgress: true,
			observe: 'events',
		});
	}

	/**
	 * POSTs a keep alive request to the server.
	 * @returns
	 */
	postKeepAlive(): Observable<void> {
		const url = this.buildUrl();
		return this.http.post<void>(url, {
			$type: Types.ApiKeepAliveRequest,
		});
	}

	private buildUrl(path = 'exec') {
		let baseUri = document.baseURI;
		if (/\.html$/i.test(baseUri)) {
			baseUri = baseUri.substring(0, baseUri.lastIndexOf('/') + 1);
		}

		const url = baseUri + `jadehttp.dll/${path}?Api`;
		return url;
	}
}
